import Env from 'env';
import { type User, UserManager } from 'oidc-client-ts';
class Auth {
  public userManager: UserManager;

  constructor() {
    this.userManager = new UserManager(Env.sts);
  }

  public getUser(): Promise<User | null> {
    return this.userManager.getUser();
  }
  public getAccessToken(): Promise<string> {
    return this.userManager.getUser().then((x) => x?.access_token as string);
  }

  public login(): Promise<void> {
    return this.userManager.signinRedirect({ state: window.location.href });
  }

  public renewToken(): Promise<User> {
    return this.userManager.signinSilent() as any;
  }

  public logout(): Promise<void> {
    return this.userManager.signoutRedirect();
  }
}
export default new Auth();
